<div class="container-fluid">
    <div class="d-flex m-2">
        <div class=" mr-2">
            <button mat-icon-button (click)="back()">
                <mat-icon style="color: #00FF00;" svgIcon="feather:arrow-left-circle"></mat-icon>
            </button>
        </div>
        <h2 class="h3 createHeading">USER ATTENDANCE</h2>
    </div>
    
    <div class="card dataCard m-1">
        <div class="m-2">
            <div class="row">
                <div class="col-sm-6 col-md-6 col-lg-4 col-xl-3 mb-4">
                    <div class="listFont ">
                        User Name:
                    </div>
                    <div class="textValue">
                        {{userName}}
                    </div>
                </div>
                <div class="col-sm-6 col-md-4 col-lg-4 col-xl-3 mb-3">
                    <div class="listFont">
                        Role:
                    </div>
                    <div class="textValue">
                        {{roleName}}
                    </div>
                </div>
            
                <div class="col-sm-6 col-md-6 col-lg-4 col-xl-3 mb-3" >
                    <div class="listFont ">
                        Active&nbsp;Branches:
                    </div>
                    <div class="textValue" 
                    
                    matTooltip='{{userActiveBranchNames.join(", ")}}'
                    > 
                        {{userActiveBranchNames.join(", ")}}
                    </div>
                </div>
                
                <div class="col-sm-6 col-md-4 col-lg-4 col-xl-3 mb-3" >
                    <div class="listFont ">
                        Previous&nbsp;Branches:
                    </div>
                    <div class="textValue"
                    matTooltip='{{userPreviousBranchNames.join(", ")}}'
                    > 
                        {{userPreviousBranchNames.join(", ")}}
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="card dataCard m-1 mt-4">
        <div class="ml-3">
            <h3 class="headings">
                User Activity
            </h3>
            <div class="row">
                <div class="col-12 row">
                    <div class="col-sm-12 col-md-3 col-lg-4">
                        <mat-form-field class="flex-auto gt-xs:pr-3" style="width: 90%;">
                            <mat-select [placeholder]="'All Branches'" [(ngModel)]="branch" (selectionChange)="onGetUserAttendanceStats()" >
                              <mat-option  value="">All Branches</mat-option>
                              <mat-option *ngFor="let branch of all_branches_list" [value]="branch.id">{{branch.name}}</mat-option>
                            </mat-select>
                          </mat-form-field>
                    </div>
                    <div class="col-sm-12 col-md-3 col-lg-4" >
                        <div class="">
                            <mat-form-field class="flex-auto gt-xs:pr-3 w-75">
                                <input matInput readonly [matDatepicker]="picker" [(ngModel)]="fromDate" [max]="newDate"
                                    [placeholder]="'From Date'" (dateChange)="onGetUserAttendanceStats()">
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>

                        </div>
                    </div>
                    <div class="col-sm-12 col-md-3  col-lg-4 " >
                        <div class="">
                            <mat-form-field class="flex-auto gt-xs:pr-3 w-75">
                                <input matInput readonly [matDatepicker]="picker1" [placeholder]="'To Date'" [(ngModel)]="toDate" [disabled]="!fromDate"
                                    [min]="fromDate" [max]="newDate" (dateChange)="onGetUserAttendanceStats()">
                                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                <mat-datepicker #picker1></mat-datepicker>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 col-md-4 col-lg-4 mb-4">
                        <div class="listFont">
                            Total Active Time: <span>{{total_active_time_stat}}</span>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-4 col-lg-4 mb-4">
                        <div class="listFont">
                            Total <span>{{dutyTimeFieldName}}</span>: <span>{{total_duty_time_stat}}</span>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-4 col-lg-4 mb-4">
                        <div class="listFont">
                            Total <span>{{overTimeFieldName}}</span>: <span>{{total_over_time_stat}}</span>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-4 col-lg-4 mb-4" *ngIf="!isCustomerRole">
                        <div class="listFont">
                            Total Working Days:<span>{{total_working_days_stat}}</span>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-4 col-lg-4 mb-4" *ngIf="!isCustomerRole">
                        <div class="listFont">
                            Week off: <span>{{total_week_off_days_stat}}</span>
                        </div>
                    </div>
                   
                </div>

            </div>

        </div>
    </div>
    <div class="mat-elevation-z8 mt-4 overflow-auto">
        <table mat-table [dataSource]="dataSource" matSort>

            <!-- ID Column -->
            <ng-container matColumnDef="logDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
                <td mat-cell *matCellDef="let row">{{row.log_date | dateFormat}} </td>

            </ng-container>

            <!-- Progress Column -->
            <ng-container matColumnDef="DutyTime">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{dutyTimeFieldName}}</th>
                <td mat-cell *matCellDef="let row">{{row.duty_time_in_seconds}}
            </ng-container>
            <ng-container matColumnDef="OverTime">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ overTimeFieldName }}</th>
                <td mat-cell *matCellDef="let row">{{row.over_time_in_seconds}}
            </ng-container>
            <ng-container matColumnDef="ActiveTime">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Total Active Time</th>
                <td mat-cell *matCellDef="let row">{{row.active_time_in_seconds}}
            </ng-container>
            <ng-container matColumnDef="arrivalStatuses">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Arrival Statuses</th>
                <td mat-cell *matCellDef="let row">{{row.arrival_statuses}} </td>
            </ng-container>
            <ng-container matColumnDef="aboutDay">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>About Day</th>
                <td mat-cell *matCellDef="let row">{{row.about_day}} </td>
            </ng-container>
            <ng-container matColumnDef="branch">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Branch</th>
                <td mat-cell *matCellDef="let row">{{row.branch?.name}} </td>
            </ng-container>
            <ng-container matColumnDef="Actions">
                <th class="text-center" mat-header-cell *matHeaderCellDef mat-sort-header>Actions</th>
                <mat-cell class="" style="height: 52px;" *matCellDef="let row;">
                    <button mat-button [matMenuTriggerFor]="menu"><mat-icon style="color:#0038FF;font-size: 30px;"
                            svgIcon="heroicons_outline:dots-vertical"></mat-icon></button>
                    <mat-menu #menu="matMenu">
                        <!-- <button mat-menu-item (click)="getBranchById(row)">View</button> -->
                        <button mat-menu-item (click)="viewUserLog(row)">View</button>
                        <!-- <button mat-menu-item (click)="editUserLog(row)"
                        [disabled]="!isUserAllowedToCreateAttendanceLog">Edit</button> -->
                        <!-- <button mat-menu-item >Reactivate</button> -->
                    </mat-menu>

                </mat-cell>

            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            <!-- Row shown when there is no matching data. -->
            <div>
                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="12">
                        <h3 style="display: flex;justify-content: center; margin:10%;">
                            No Records Found
                        </h3>
                    </td>
                </tr>
            </div>
        </table>
    </div>
    <mat-paginator style="display:flex;justify-content: end;" 
    #paginator
    (page)="onPaginateChange($event)" [length]="totalCount"
    [pageIndex]="pageIndex" [pageSize]="pageSize" [pageSizeOptions]="[10, 25, 100]"
    aria-label="Select page of users" showFirstLastButtons></mat-paginator>
</div>